// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"ac584f6f","453":"2d2ca95d"}[chunkId] + ".chunk.js";
};